<div
  #mainNotification
  *ngIf="appConfig?.config?.endOfServiceDate ||
    appConfig?.config?.applicationReadOnlyMode ||
    (appConfig?.config?.migration?.bannerEnabled && accountConsentsService.migrationConsentActive) ||
    (!appConfig?.config?.payment?.autoPayment?.enabled && customerStoreService.hasConfiguredAutomaticPayments()) ||
    appConfig?.config?.features?.displayCardMigrationIsUnderWay"
  class="main-notification flex flex-row items-center">
  <div class="notification-content">
    <p *ngIf="appConfig?.config?.endOfServiceDate">
      Rachunki imoje kończy swoją działalność {{ appConfig.config.endOfServiceDate }}
    </p>
    <p *ngIf="appConfig?.config?.migration?.bannerEnabled && accountConsentsService.migrationConsentActive">
      Uwaga! 1 września 2022 zmieni się operator platformy. Wyraź zgodę na migrację, aby Twoje konto nie zostało
      usunięte.
    </p>
    <p *ngIf="appConfig?.config?.applicationReadOnlyMode">
      Widoczne dane pochodzą z dnia 30.04.2022, ich edycja została zablokowana.&nbsp;
      <a
        href="https://payka.pl/blog/zamykamy-serwis-rachunki-imoje/"
        target="_blank"
        class="redirect-notification toolbar-link"
      >Dowiedz się więcej</a>
    </p>
    <p
      *ngIf="!appConfig?.config?.payment?.autoPayment?.enabled && customerStoreService.hasConfiguredAutomaticPayments()">
      Płatności kartą oraz funkcja autopłatności są tymczasowo niedostępne. By dowiedzieć się więcej kliknij
      <a
        href="https://payappka.document360.io/docs/najczestsze-powody-odrzucenia-p%C5%82atnosci-karta-dlaczego-tak-mog%C5%82o-sie-stac"
        target="_blank"
        class="toolbar-link"
      >tutaj</a>
    </p>
    <p *ngIf="appConfig?.config?.features?.displayCardMigrationIsUnderWay">
      Płatności kartą są już dostępne dla nowo dodanych kart. Trwa proces migracji kart przez operatora i do jego
      zakończenia autopłatności są wyłączone. Migracja powinna się zakończyć do 13.10.2022. By dowiedzieć się więcej
      kliknij
      <a href="https://payappka.document360.io/" target="_blank" class="toolbar-link">tutaj</a>
    </p>
  </div>

  <button
    (click)="onFetchCustomerDataClick()"
    *ngIf="appConfig?.config?.endOfServiceDate"
    class="download-data-button"
    mat-stroked-button>
    POBIERZ SWOJE DANE
  </button>
  <button
    (click)="onMigrationConsentsClick()"
    *ngIf="appConfig?.config?.migration?.bannerEnabled && accountConsentsService.migrationConsentActive"
    class="download-data-button"
    [ngClass]="{ xs: handsetService.isXs }"
    mat-stroked-button>
    Kontynuuj
  </button>
</div>
<mat-toolbar ngClass.lt-md="topo">
  <a fxFlex="none" class="logo" routerLink="/dashboard"
     *ngIf="(handsetService.handsetChanges | async) === false ||
     (handsetService.handsetChanges | async) === null ||
     (handsetService.handsetChanges | async) === undefined">
    <img alt="payka.pl" src="/assets/images/logo-payka/logo_payka.svg" />
  </a>

  <ng-container>
    <button
      mat-icon-button
      class="menu-toggle"
      *ngIf="(handsetService.handsetChanges | async) && toolbarDefinition.mainBtn === 'menu'"
      (click)="toolbarService.openDrawer()">
      <app-icon class="toolbar-icon" name="menu"></app-icon>
    </button>

    <button
      mat-icon-button
      class="menu-toggle"
      *ngIf="(handsetService.handsetChanges | async) && toolbarDefinition.mainBtn === 'close'"
      (click)="toolbarService.closeDrawer()"
      [disabled]="loadingService.loading$ | async">
      <app-icon class="toolbar-icon" name="close"></app-icon>
    </button>
    <button
      mat-icon-button
      class="menu-toggle"
      *ngIf="(handsetService.handsetChanges | async) && toolbarDefinition.mainBtn === 'back'"
      (click)="toolbarService.backClicked.next(true)"
      [disabled]="loadingService.loading$ | async">
      <app-icon class="toolbar-icon" name="arrow_back"></app-icon>
    </button>
  </ng-container>

  <div class="title-wrapper">
    <div fxFlex class="title"
         *ngIf="!(searchVisible && toolbarDefinition?.search && (handsetService.xsChanges | async))"
         ngClass.xs="xs">
      <span>{{ toolbarDefinition?.title }}</span>
    </div>

    <ng-container *ngIf="toolbarDefinition?.search && searchVisible">
      <div class="search-container" ngClass.xs="xs" fxFlex="0 1 960px" fxFlex.lt-lg="100"
           fxLayout="row" fxLayoutAlign="start center">
        <div class="search flex flex-1 flex-row items-center justify-start">
          <app-icon name="search" class="icon-search"></app-icon>

          <input [formControl]="search"
                 fxFlex
                 [placeholder]="toolbarDefinition?.searchPlaceholder"
                 [maxlength]="100"
                 [appInputMaxLength]="100" />
          <button mat-icon-button
                  (click)="clearSearch()"
                  *ngIf="(handsetService.handsetChanges | async) && toolbarDefinition.mainBtn === 'close'"
                  [disabled]="loadingService.loading$ | async">
            <app-icon name="close"></app-icon>
          </button>
          <button mat-icon-button
                  class="menu-toggle"
                  *ngIf="(handsetService.handsetChanges | async) && toolbarDefinition.mainBtn === 'menu'"
                  (click)="toolbarService.openDrawer()">
            <app-icon name="menu"></app-icon>
          </button>
        </div>
      </div>
    </ng-container>

    <div *ngIf="appConfig.config.features.showUnusedSubpages && searchToggleVisible && toolbarDefinition?.search"
         [class.flex-100]="!toolbarDefinition?.tagFilter"
         class="flex flex-row items-center justify-center">
      <div fxFlex></div>
      <button mat-icon-button fxFlex="none" class="search-toggle" (click)="showSearch()" ngClass.xs="xs">
        <app-icon name="search"></app-icon>
      </button>
    </div>

    <div
      *ngIf="(handsetService.xsChanges | async) === false ||
      (handsetService.xsChanges | async) === null ||
      (handsetService.xsChanges | async) === undefined
      || !searchVisible || !toolbarDefinition?.search"
      class="avatar-section flex flex-row flex-1 items-center justify-end">
      <app-toolbar-additional-info
        *ngIf="appConfig.config.features.showUnusedSubpages
        && appConfig.config.features.memberGetMemberEnabled
        && appConfig.config.referral.active
        && ((handsetService.handsetChanges | async) === false
            || (handsetService.handsetChanges | async) === null
            || (handsetService.handsetChanges | async) === undefined)"
        [message]="promotionCouponsService.statusMessage$ | async"
        [icon]="appConfig.config.visaContest.enabled ? 'emoji_events' : 'redeem'"
        [class]="'status-ok'"
        [routerLink]="appConfig.config.visaContest?.enabled ? '/rachunkisieplaca' : '/promotion-coupons'">
      </app-toolbar-additional-info>

      <ng-container *ngIf="appConfig.config.features.showUnusedSubpages && configurationMessage$ | async as model">
        <app-toolbar-additional-info
          *ngIf="(handsetService.handsetChanges | async) === false ||
          (handsetService.handsetChanges | async) === null ||
          (handsetService.handsetChanges | async) === undefined && !model.hidden"
          message="Konfiguracja {{ model.scoreSum }}%"
          [icon]="'speed'"
          [class]="'status-pending'"
          (click)="configurationToolbarClicked()"
          [routerLink]="'/dashboard'">
        </app-toolbar-additional-info>
      </ng-container>

      <div *ngIf="!customerService.isMedium()" style="width: 170px;">
        <button class="account-status light-pink-button" (click)="verifyAccountClick()">
          <span>Zweryfikuj się</span>
        </button>
      </div>
      <div class="flex flex-col items-end mr-16" ngClass.xs="xs">
        <app-cart-button></app-cart-button>
      </div>
      <div class="flex flex-col items-end mr-16" ngClass.xs="xs">
        <app-notifications-container></app-notifications-container>
      </div>

      <div *ngIf="isImpersonalization" class="flex flex-col items-end mr-16" ngClass.xs="xs">
        <button
          aria-label="Powrót"
          (click)="revertImpersonalization()"
          type="button"
          class="clear-button icon-button">
          <app-icon name="arrow_back" color="red"></app-icon>
        </button>
      </div>


      <div fxLayout="column" fxLayoutAlign="center center" class="menu-trigger" [matMenuTriggerFor]="userMenu">
        <div class="avatar-container" ngClass.xs="xs">
          <app-avatar
            [label]="customerStoreService.state.nick?.substring(0, 1).toUpperCase()"
            [matTooltip]="customerStoreService.state.nick"
            [showPointer]="true"
            [fontSize]="'14px'"
          >
          </app-avatar>
          <!--          <ngx-avatar-->
          <!--            [size]="42"-->
          <!--            [name]="customerStoreService.state.nick?.substring(0, 1).toUpperCase()"-->
          <!--            [src]="photoUrl"-->
          <!--            -->
          <!--            size="64"-->
          <!--          ></ngx-avatar>-->

          <!--
            //todo

          -->

        </div>
      </div>

      <mat-menu #userMenu [overlapTrigger]="false">
        <h1>{{ customerStoreService.state.nick }}</h1>

        <mat-divider></mat-divider>

        <a *ngIf="appConfig.config.couponsPage.enabled" mat-menu-item routerLink="/promotion-coupons">
          <app-icon class="red-icon" name="favorite" [height]="18" [width]="18"></app-icon>
          Poleć znajomym
        </a>

        <a mat-menu-item routerLink="/settings">
          <app-icon name="settings" [height]="18" [width]="18"></app-icon>
          Ustawienia
        </a>


        <a href="https://payka.pl/pytania-i-odpowiedzi/" mat-menu-item target="_blank">
          <app-icon name="contact_support" [height]="18" [width]="18"></app-icon>
          Pomoc
        </a>

        <button mat-menu-item (click)="logout()">
          <app-icon name="power_settings" [height]="18" [width]="18"></app-icon>
          Wyloguj
        </button>
      </mat-menu>
    </div>
    <div
      *ngIf="appConfig.config.features.showUnusedSubpages
        && toolbarDefinition?.progressPercentage
        && ((handsetService.xsChanges | async) === false
            || (handsetService.xsChanges | async) === null
            || (handsetService.xsChanges | async) === undefined)"
      class="progress"
      [style.width]="toolbarDefinition?.progressPercentage + '%'">
    </div>
  </div>

  <div *ngIf="toolbarDefinition?.progressPercentage && (handsetService.xsChanges | async)"
       class="progress xs"
       [style.width]="toolbarDefinition?.progressPercentage + '%'">
  </div>
</mat-toolbar>
